export const translations = {
  de: {
    nav: { services: "Leistungen", team: "Team", projects: "Projekte", contact: "Kontakt" },
    header: { contactLabel: "Ihr Kontakt" },
    hero: {
      overline: "Messebau · Ottikon, Zürcher Oberland",
      title1: "Klein.",
      title2: "Präzise.",
      title3: "Das beste Team.",
      sub: "Wir sind nur 2 denkende Köpfe – und genau das ist unsere Stärke. Vollmermontagen GmbH baut und montiert Messestände, die auffallen. Persönlich, zuverlässig, ohne Umwege.",
      cta1: "Projekt anfragen",
      cta2: "Unsere Projekte",
      stat1: "2 denkende Köpfe",
      stat1Label: "ein eingespieltes Team",
      stat2: "100 %",
      stat2Label: "Handarbeit & Herzblut",
      stat3: "0",
      stat3Label: "Aufträge zu spät geliefert",
    },
    services: {
      overline: "Was wir machen",
      title: "Unsere Leistungen",
      sub: "Vom Messestand bis zu den Schreiner-Montagen – alles aus einer Hand.",
      items: [
        { title: "Messestandbau", desc: "Individuelle Messestände, geplant und gebaut in eigener Regie. Vom Systemstand bis zum massgeschneiderten Sonderbau." },
        { title: "Montage & Demontage", desc: "Pünktlich aufgebaut, sauber abgebaut. Wir sind vor Ort, bevor die Halle öffnet – und bleiben, bis alles steht." },
        { title: "Schreiner-Montagen", desc: "Ihr liefert die Pläne, wir liefern die Montage: von der Küche bis zum Katzenbaum bauen wir fachgerecht auf – präzise, sauber und termingerecht." },
        { title: "Beratung & Planung", desc: "Ehrliche Beratung ohne Verkaufsdruck. Wir denken mit, rechnen transparent und finden die passende Lösung für Ihr Budget." },
      ],
    },
    team: {
      overline: "Nur zu zweit – aber das beste Team",
      title: "Das sind wir",
      sub: "Kein Callcenter, keine Warteschleife. Sie sprechen immer direkt mit den Menschen, die Ihren Stand auch bauen.",
      members: [
        { name: "Remo Vollmer", role: "Geschäftsführer", bio: "Gründer und Chef. Plant jedes Projekt persönlich und steht selbst mit auf der Baustelle." },
        { name: "Joe Piercy", role: "Mitglied der Geschäftsleitung", bio: "Unser Mann für die Montage. Wenn Joe schraubt, steht der Stand – garantiert." },
      ],
    },
    network: {
      overline: "Verstärkung auf Abruf",
      title: "Grösserer Stand geplant?",
      text: "Für grosse Projekte rufen wir erfahrene Monteure und Fachkräfte aus unserem bewährten Netzwerk dazu. Ihr habt trotzdem nur einen Ansprechpartner: uns.",
      cta: "Projekt anfragen",
    },
    gallery: {
      overline: "Referenzen",
      title: "Unsere Projekte",
      sub: "Ein Blick hinter die Kulissen und auf unsere fertigen Stände.",
      items: [
        { title: "Messe Bern Swiss Transport", tag: "Messestand KSU" },
        { title: "Messe Paris Kongress Cigre", tag: "Messestände & Video" },
        { title: "Messe Bern Swiss Public", tag: "Video" },
        { title: "Messe Lenzburg LEGA", tag: "Video" },
      ],
    },
    contact: {
      overline: "Kontakt",
      title: "Lassen Sie uns über Ihr Projekt sprechen",
      sub: "Erzählen Sie uns kurz, was Sie vorhaben – wir melden uns innert 24 Stunden persönlich bei Ihnen.",
      addressLabel: "Adresse",
      address: "Hinwilerstrasse 11, 8626 Ottikon",
      emailLabel: "E-Mail",
      phoneLabel: "Telefon",
      officeHours: "Büro: 09:00–18:00 · Mobile: 07:00–20:00",
      form: {
        name: "Ihr Name",
        namePlaceholder: "Max Muster",
        email: "Ihre E-Mail",
        emailPlaceholder: "max@firma.ch",
        message: "Ihre Nachricht",
        messagePlaceholder: "Wir brauchen einen Stand für die Messe in ...",
        submit: "Nachricht senden",
        sending: "Wird gesendet ...",
        success: "Merci! Ihre Nachricht ist angekommen – wir melden uns innert 24 Stunden.",
        error: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut oder schreiben Sie uns direkt per E-Mail.",
      },
    },
    footer: {
      tagline: "Messebau mit Handschrift. Klein, präzise, persönlich.",
      legal: "Impressum",
      privacy: "Datenschutz",
      rights: "Alle Rechte vorbehalten.",
    },
  },
  en: {
    nav: { services: "Services", team: "Team", projects: "Projects", contact: "Contact" },
    header: { contactLabel: "Your contact" },
    hero: {
      overline: "Exhibition stand construction · Ottikon, Zurich",
      title1: "Small.",
      title2: "Precise.",
      title3: "The best team.",
      sub: "We are only 2 thinking minds – and that is exactly our strength. Vollmermontagen GmbH builds and assembles exhibition stands that get noticed. Personal, reliable, no detours.",
      cta1: "Request a project",
      cta2: "Our projects",
      stat1: "2 thinking minds",
      stat1Label: "one well-rehearsed team",
      stat2: "100 %",
      stat2Label: "craftsmanship & passion",
      stat3: "0",
      stat3Label: "jobs delivered late",
    },
    services: {
      overline: "What we do",
      title: "Our services",
      sub: "From exhibition stands to carpentry assembly – everything from a single source.",
      items: [
        { title: "Stand construction", desc: "Custom exhibition stands, planned and built in-house. From modular system stands to fully bespoke builds." },
        { title: "Assembly & dismantling", desc: "Set up on time, taken down cleanly. We are on site before the hall opens – and stay until everything stands." },
        { title: "Carpentry assembly", desc: "You supply the plans, we handle the assembly: from the kitchen to the cat tree, we install it professionally – precise, clean and on schedule." },
        { title: "Consulting & planning", desc: "Honest advice without sales pressure. We think along, calculate transparently and find the right solution for your budget." },
      ],
    },
    team: {
      overline: "Only two of us – but the best team",
      title: "Meet the team",
      sub: "No call centre, no hold music. You always talk directly to the people who actually build your stand.",
      members: [
        { name: "Remo Vollmer", role: "Managing Director", bio: "Founder and boss. Plans every project personally and is on the construction site himself." },
        { name: "Joe Piercy", role: "Member of the Executive Board", bio: "Our assembly man. When Joe tightens a screw, the stand stands – guaranteed." },
      ],
    },
    network: {
      overline: "Reinforcements on call",
      title: "Planning a bigger stand?",
      text: "For large projects we call in experienced fitters and skilled workers from our trusted network. You still have just one point of contact: us.",
      cta: "Request a project",
    },
    gallery: {
      overline: "References",
      title: "Our projects",
      sub: "A look behind the scenes and at our finished stands.",
      items: [
        { title: "Messe Bern Swiss Transport", tag: "Exhibition stand KSU" },
        { title: "Messe Paris Kongress Cigre", tag: "Exhibition stands & video" },
        { title: "Messe Bern Swiss Public", tag: "Video" },
        { title: "Messe Lenzburg LEGA", tag: "Video" },
      ],
    },
    contact: {
      overline: "Contact",
      title: "Let's talk about your project",
      sub: "Tell us briefly what you are planning – we will get back to you personally within 24 hours.",
      addressLabel: "Address",
      address: "Hinwilerstrasse 11, 8626 Ottikon, Switzerland",
      emailLabel: "Email",
      phoneLabel: "Phone",
      officeHours: "Office: 09:00–18:00 · Mobile: 07:00–20:00",
      form: {
        name: "Your name",
        namePlaceholder: "John Doe",
        email: "Your email",
        emailPlaceholder: "john@company.com",
        message: "Your message",
        messagePlaceholder: "We need a stand for the trade fair in ...",
        submit: "Send message",
        sending: "Sending ...",
        success: "Thank you! Your message has arrived – we will get back to you within 24 hours.",
        error: "Something went wrong. Please try again or email us directly.",
      },
    },
    footer: {
      tagline: "Exhibition construction with a signature. Small, precise, personal.",
      legal: "Legal notice",
      privacy: "Privacy",
      rights: "All rights reserved.",
    },
  },
  fr: {
    nav: { services: "Prestations", team: "Équipe", projects: "Projets", contact: "Contact" },
    header: { contactLabel: "Votre contact" },
    hero: {
      overline: "Construction de stands · Ottikon, Zurich",
      title1: "Petit.",
      title2: "Précis.",
      title3: "La meilleure équipe.",
      sub: "Nous ne sommes que 2 esprits pensants – et c'est exactement notre force. Vollmermontagen GmbH construit et monte des stands d'exposition qui se remarquent. Personnel, fiable, sans détours.",
      cta1: "Demander un projet",
      cta2: "Nos projets",
      stat1: "2 esprits pensants",
      stat1Label: "une équipe bien rodée",
      stat2: "100 %",
      stat2Label: "artisanat & passion",
      stat3: "0",
      stat3Label: "missions livrées en retard",
    },
    services: {
      overline: "Ce que nous faisons",
      title: "Nos prestations",
      sub: "Du stand d'exposition au montage de menuiserie – tout d'une seule main.",
      items: [
        { title: "Construction de stands", desc: "Stands d'exposition sur mesure, planifiés et construits en interne. Du stand modulaire à la réalisation entièrement personnalisée." },
        { title: "Montage & démontage", desc: "Monté à temps, démonté proprement. Nous sommes sur place avant l'ouverture du hall – et nous restons jusqu'à ce que tout soit debout." },
        { title: "Montage de menuiserie", desc: "Vous fournissez les plans, nous nous chargeons du montage : de la cuisine à l'arbre à chat, nous montons dans les règles de l'art – précis, propre et ponctuel." },
        { title: "Conseil & planification", desc: "Des conseils honnêtes, sans pression commerciale. Nous réfléchissons avec vous, calculons en toute transparence et trouvons la solution adaptée à votre budget." },
      ],
    },
    team: {
      overline: "Seulement deux – mais la meilleure équipe",
      title: "Voici l'équipe",
      sub: "Pas de centre d'appels, pas de musique d'attente. Vous parlez toujours directement aux personnes qui construisent réellement votre stand.",
      members: [
        { name: "Remo Vollmer", role: "Directeur général", bio: "Fondateur et patron. Il planifie chaque projet personnellement et se trouve lui-même sur le chantier." },
        { name: "Joe Piercy", role: "Membre de la direction", bio: "Notre homme du montage. Quand Joe serre une vis, le stand tient – garanti." },
      ],
    },
    network: {
      overline: "Renforts sur appel",
      title: "Un stand plus grand en vue ?",
      text: "Pour les grands projets, nous faisons appel à des monteurs et ouvriers qualifiés de notre réseau éprouvé. Vous n'avez quand même qu'un seul interlocuteur : nous.",
      cta: "Demander un projet",
    },
    gallery: {
      overline: "Références",
      title: "Nos projets",
      sub: "Un regard dans les coulisses et sur nos stands terminés.",
      items: [
        { title: "Messe Bern Swiss Transport", tag: "Stand KSU" },
        { title: "Messe Paris Kongress Cigre", tag: "Stands & vidéo" },
        { title: "Messe Bern Swiss Public", tag: "Vidéo" },
        { title: "Messe Lenzburg LEGA", tag: "Vidéo" },
      ],
    },
    contact: {
      overline: "Contact",
      title: "Parlons de votre projet",
      sub: "Dites-nous en quelques mots ce que vous prévoyez – nous vous répondrons personnellement sous 24 heures.",
      addressLabel: "Adresse",
      address: "Hinwilerstrasse 11, 8626 Ottikon, Suisse",
      emailLabel: "E-mail",
      phoneLabel: "Téléphone",
      officeHours: "Bureau : 09h00–18h00 · Mobile : 07h00–20h00",
      form: {
        name: "Votre nom",
        namePlaceholder: "Jean Dupont",
        email: "Votre e-mail",
        emailPlaceholder: "jean@entreprise.ch",
        message: "Votre message",
        messagePlaceholder: "Nous avons besoin d'un stand pour le salon de ...",
        submit: "Envoyer le message",
        sending: "Envoi en cours ...",
        success: "Merci ! Votre message est bien arrivé – nous vous répondrons sous 24 heures.",
        error: "Une erreur s'est produite. Veuillez réessayer ou nous écrire directement par e-mail.",
      },
    },
    footer: {
      tagline: "Construction de stands avec une signature. Petit, précis, personnel.",
      legal: "Mentions légales",
      privacy: "Confidentialité",
      rights: "Tous droits réservés.",
    },
  },
};

export const LANGUAGES = [
  { code: "de", label: "DE" },
  { code: "en", label: "EN" },
  { code: "fr", label: "FR" },
];
